import { render, staticRenderFns } from "./addressManagement.vue?vue&type=template&id=11d11a3c&"
import script from "./addressManagement.vue?vue&type=script&lang=js&"
export * from "./addressManagement.vue?vue&type=script&lang=js&"
import style0 from "./addressManagement.vue?vue&type=style&index=0&id=11d11a3c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports